import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Slide,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import AppDataContext from "../../../common/appContext";
import Helper from "../../../common/Helper";
import { Role } from "../../../helper";
import { GameScoreServices } from "../../../services/gameScore.Services";

//#Icons
import JpgIcon from "../../../sharedComponents/customIcons/JpgIcon";
import PngIcon from "../../../sharedComponents/customIcons/PngIcon";
import TxtIcon from "../../../sharedComponents/customIcons/TxtIcon";
import WordIcon from "../../../sharedComponents/customIcons/WordIcon";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

//... Services Imports.
import { gameScoreBaseUrl } from "../../../services";

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerBox: {
    background: "#c1d0ed",
  },
  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  tableRow: {
    "&:nth-child(odd)": {
      background: "#f5f5f5",
    },
    "& .MuiTableCell-root": {
      borderBottom: "none",
    },
  },
  iconStyle: {
    width: "26px",
    height: "26px",
    cursor: "pointer",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AnthrosUploadPlayerPHA({ playerData }) {
  const classes = useStyles();

  //... Get data from Context.
  const { selectedEventId, user } = useContext(AppDataContext);
  let userAppRoles = user.appRoles || [];

  //... Document Listing  data holders.
  const [documentList, setDocumentList] = useState([]);

  //... Loader data holders
  const [loading, setLoading] = useState(false);

  //... Pagination Data holders.
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);

  //... Document refs data holders.
  const elementRef = useRef();

  //... Dialog Data holders.
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  //... Alert data holders.
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (Object.keys(playerData).length > 0 && Object.keys(user).length > 0) {
      GetUploadedPlayerPHADocuments();
    }
  }, [playerData, user]);

  const GetUploadedPlayerPHADocuments = async () => {
    setLoading(true);
    setDocumentList([]);
    try {
      const result = await GameScoreServices.getUploadedPHADocuments(
        playerData.eventId || 0,
        "DexaBodyFat",
        playerData.playerID || 0,
        108
      );
      setLoading(false);
      setDocumentList(result?.data || []);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleDeletePHADocument = (obj, mode) => {
    elementRef.current = {
      ...obj,
      mode: mode,
      isDeleted: true,
      source: "delete",
    };
    setOpenDeleteDialog(true);
  };

  const handleDeletePHADialogClose = () => {
    setOpenDeleteDialog(false);
  };

  const handleDeletePHADialogAgree = () => {
    setOpenDeleteDialog(false);
    updatePHADocumentDetails();
  };

  const handlePHAFileClick = async ({ docId, displayName, fileExtension }) => {
    try {
      const { data: url } = await GameScoreServices.getDexaBodyFatUrlByDocID(
        docId
      );

      // Dynamically create an anchor element
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = `${displayName}.${fileExtension}`; // Specify the filename for download

      // Append the anchor element to the body
      document.body.appendChild(downloadLink);

      // Trigger click event on the anchor element
      downloadLink.click();

      // Clean up: remove the anchor element
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Error while fetching document details..");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const updatePHADocumentDetails = async () => {
    setLoading(true);

    try {
      const result = await GameScoreServices.uploadGameScoreDocument(
        elementRef.current
      );
      if (result.data) {
        const alertMsg =
          elementRef.current.source === "delete"
            ? "Document deleted successfully"
            : "Document details updated successfully";

        toggleAlert(true, "success", alertMsg);
        GetUploadedPlayerPHADocuments();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getFileSourceIcon = (type) => {
    switch (type) {
      case "png":
        return <PngIcon className={classes.iconStyle} color="secondary" />;
      case "jpg":
        return <JpgIcon className={classes.iconStyle} color="secondary" />;
      case "txt":
        return <TxtIcon className={classes.iconStyle} color="primary" />;
      case "docx":
        return (
          <WordIcon
            sx={{
              color: "#309ac1",
              width: "26px",
              height: "26px",
              cursor: "pointer",
            }}
          />
        );
      case "pdf":
        return (
          <PictureAsPdfIcon className={classes.iconStyle} color="secondary" />
        );
      case "xlsx":
        return (
          <img
            alt="excel icon"
            src="../../../../playerProfile/excel.png"
            height="23px"
            width="23px"
          />
        );
      default:
        return <TxtIcon className={classes.iconStyle} color="primary" />;
    }
  };

  const toggleAlert = (value, type, message) => {
    setAlert(value);
    setAlertType(type);
    setAlertMessage(message);
  };

  return (
    <Box>
      {loading && (
        <div className={classes.overlay}>
          <CircularProgress />
        </div>
      )}

      <Container maxWidth={false}>
        {/* View Game Score Documents Section */}
        <Paper elevation={3} sx={{ my: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                View Documents
              </Typography>
            </Box>
          </Box>

          <Box p={2}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableCell sx={{ padding: "0.2rem" }}>
                    Document Name
                  </TableCell>
                  <TableCell sx={{ padding: "0.2rem" }}>Updated On</TableCell>
                  <TableCell sx={{ padding: "0.2rem" }}>Uploaded By</TableCell>
                  <TableCell sx={{ padding: "0.2rem" }}></TableCell>
                </TableHead>
                <TableBody>
                  {documentList.length > 0 ? (
                    documentList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((document, index) => {
                        const {
                          fileExtension,
                          displayName,
                          createdDate,
                          userBy,
                        } = document;
                        return (
                          <TableRow key={index} className={classes.tableRow}>
                            <TableCell style={{ padding: "0.2rem" }}>
                              {displayName}
                            </TableCell>
                            <TableCell style={{ padding: "0.2rem" }}>
                              {Helper.FormatDate(moment(createdDate).format())}
                            </TableCell>
                            <TableCell style={{ padding: "0.2rem" }}>
                              {userBy}
                            </TableCell>
                            <TableCell style={{ padding: "0.2rem" }}>
                              <Stack direction="row" spacing={2}>
                                <Box>
                                  <Button
                                    onClick={() => handlePHAFileClick(document)}
                                  >
                                    {getFileSourceIcon(fileExtension)}
                                  </Button>
                                </Box>

                                {user && user.isAdmin ? (
                                  <Box>
                                    <DeleteOutlineIcon
                                      sx={{
                                        color: "red",
                                        width: "26px",
                                        height: "26px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleDeletePHADocument(document, "D")
                                      }
                                    />
                                  </Box>
                                ) : null}
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={
                documentList && documentList.length > 0
                  ? documentList.length
                  : 0
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ width: "100%" }}
            />
          </Box>
        </Paper>

        {/* Document Delete Dialog Box */}
        <Dialog
          open={openDeleteDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleDeletePHADialogClose}
          aria-describedby="alert-delete-dialog-slide-description"
          maxWidth="lg"
          PaperProps={{
            style: {
              width: "40%",
            },
          }}
        >
          <DialogTitle>Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Do you wish to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDeletePHADialogClose}
              variant="contained"
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeletePHADialogAgree}
              variant="contained"
              color="primary"
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {/* Common Snack bar for all tabs */}
        <Snackbar
          open={alert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          onClose={() => setAlert(false)}
        >
          <Alert
            onClose={() => setAlert(false)}
            severity={alertType}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
}

export default AnthrosUploadPlayerPHA;
